import type { FC } from 'react'

export const ApplicantName: FC<{ name: string }> = ({ name }) => {
  return (
    <div>
      <div className="font-medium leading-6 text-muted-foreground">Applicant</div>
      <div className="text-2xl font-bold leading-9">{name}</div>
    </div>
  )
}
